import {
  changeActive,
  changeAgenda,
  changeApprove,
  changeEmail,
  givePremium,
  removePremium,
  changeCRPPhotos,
} from "@/views/Users/UserDetail/userFunctions";
import { Modal } from "bootstrap";
import { email, required } from "vuelidate/lib/validators";
import {
  PsiDetailAppointments,
  PsiDetailBankInfo,
  PsiDetailCoupons,
  PsiDetailPayouts,
  PsiDetailProfile,
  PsiDetailRatings,
  PsiDetailRegisterInfo,
  PsiDetailSchedules,
  PsiDetailSummary,
  PsiDetailSubscriptions,
  PsiDetailConnectAccounts,
  PsiDetailRecurrencies,
} from "./PsiDetailComponents";
import UserChangeLogsTab from "@/components/UserChangeLogsTab.vue";

export default {
  mounted() {
    this.changeEmailModal = new Modal(
      document.getElementById("changeEmailModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.changeCRPPhotosModal = new Modal(
      document.getElementById("changeCRPPhotosModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      isApproving: false,
      showSummary: true,
      changeEmailModal: null,
      changeCRPPhotosModal: null,
      item: {},
      id: this.$route.params.id,
      loadingItems: false,
      submitting: false,
      errorMessage: "",
      changeLogsLoaded: false,
      connectAccountsLoaded: false,
      appointmentsLoaded: false,
      adminLogsLoaded: false,
      notificationsLoaded: false,
      diagnosticLoaded: false,
      activeTab: this.$route.query.tab || "account",
      tabGroups: [
        {
          id: "cadastro",
          label: "Cadastro",
          icon: "fa-solid fa-user",
          tabs: [
            { id: "account", label: "Situação" },
            { id: "account-data", label: "Informações cadastrais" },
            { id: "account-docs", label: "Documentos" },
            { id: "schedule", label: "Horários" },
            { id: "bank", label: "Dados bancários" },
          ],
        },
        {
          id: "sessoes",
          label: "Sessões",
          icon: "far fa-calendar-check",
          tabs: [
            { id: "appointments", label: "Sessões" },
            { id: "recurrencies", label: "Recorrências" },
            { id: "review", label: "Avaliações" },
            { id: "coupons", label: "Cupons" },
          ],
        },
        {
          id: "financeiro",
          label: "Financeiro",
          icon: "fa-solid fa-dollar-sign",
          tabs: [
            { id: "subscriptions", label: "Assinaturas" },
            { id: "transfer", label: "Repasses" },
            { id: "connect-accounts", label: "Contas Stripe Connect" },
          ],
        },
        {
          id: "diagnostico",
          label: "Diagnóstico",
          icon: "fa-solid fa-stethoscope",
          tabs: [{ id: "diagnostic", label: "Diagnóstico" }],
        },
        {
          id: "historico",
          label: "Histórico",
          icon: "fa-solid fa-clock-rotate-left",
          tabs: [
            { id: "change-logs", label: "Histórico de Alterações" },
            { id: "admin-logs", label: "Logs de Admin" },
            { id: "notifications", label: "Notificações" },
          ],
        },
      ],
      form: {
        email: "",
      },
      changeCRPPhotosForm: {
        document_image: null,
        document_in_hand: null,
      },
      documentImagePreview: null,
      documentInHandPreview: null,
      showReactivateModal: false,
      confirmReactivate: false,
      reactivating: false,
      showResetPasswordModal: false,
      generatingResetLink: false,
      resetPasswordLink: null,
    };
  },
  components: {
    PsiDetailRegisterInfo,
    PsiDetailProfile,
    PsiDetailSchedules,
    PsiDetailBankInfo,
    PsiDetailAppointments,
    PsiDetailPayouts,
    PsiDetailRatings,
    PsiDetailCoupons,
    PsiDetailSummary,
    PsiDetailSubscriptions,
    PsiDetailConnectAccounts,
    PsiDetailRecurrencies,
    UserChangeLogsTab,
  },
  computed: {
    activeGroupId() {
      const group = this.groupForTab(this.activeTab);
      return group ? group.id : "cadastro";
    },
    activeGroupTabs() {
      const group = this.groupForTab(this.activeTab);
      return group ? group.tabs : [];
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
    changeCRPPhotosForm: {
      document_image: {
        required,
      },
      document_in_hand: {
        required,
      },
    },
  },
  methods: {
    cropEndDocumentImage(image) {
      this.$set(this.changeCRPPhotosForm, "document_image", image);
    },
    cropEndDocumentInHand(image) {
      this.$set(this.changeCRPPhotosForm, "document_in_hand", image);
    },
    handleDocumentImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.$set(this.changeCRPPhotosForm, "document_image", { file });
      this.$set(this, "documentImagePreview", {
        url: URL.createObjectURL(file),
        isPdf: file.type === "application/pdf",
      });
    },
    handleDocumentInHandChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.$set(this.changeCRPPhotosForm, "document_in_hand", { file });
      this.$set(this, "documentInHandPreview", {
        url: URL.createObjectURL(file),
        isPdf: file.type === "application/pdf",
      });
    },
    resetCRPPhotosForm() {
      this.changeCRPPhotosForm = { document_image: null, document_in_hand: null };
      this.documentImagePreview = null;
      this.documentInHandPreview = null;
    },
    async getData() {
      try {
        const res = await this.$userService.show(this.id);
        let data = this.$userService.preparePsi(res.data);
        const couponsRes = await this.$couponsService.list({
          psychologist_id: this.id,
        });
        data.coupons = couponsRes.data.map((r) =>
          this.$couponsService.prepareCoupon(r)
        );
        this.$set(this, "item", data);
        this.$set(this.form, "email", data.email);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
        // Aplica os efeitos da aba vinda da URL (lazy load, painel lateral)
        this.$nextTick(() => this.applyTabSideEffects(this.activeTab));
      }
    },
    groupForTab(tabId) {
      return this.tabGroups.find((g) => g.tabs.some((t) => t.id === tabId));
    },
    isSummaryTab(tabId) {
      return [
        "account",
        "account-data",
        "account-docs",
        "schedule",
        "bank",
      ].includes(tabId);
    },
    applyTabSideEffects(tabId) {
      const loaders = {
        appointments: () => this.loadAppointmentsTab(),
        subscriptions: () => this.loadSubscriptionsTab(),
        "connect-accounts": () => this.loadConnectAccountsTab(),
        "change-logs": () => this.loadChangeLogsTab(),
        "admin-logs": () => this.loadAdminLogsTab(),
        notifications: () => this.loadNotificationsTab(),
        diagnostic: () => {
          this.diagnosticLoaded = true;
        },
      };
      this.showSummary = this.isSummaryTab(tabId);
      if (loaders[tabId]) loaders[tabId]();
    },
    selectTab(tabId) {
      this.activeTab = tabId;
      this.applyTabSideEffects(tabId);
      if (this.$route.query.tab !== tabId) {
        this.$router
          .replace({ query: { ...this.$route.query, tab: tabId } })
          .catch(() => {});
      }
    },
    openCortesia() {
      this.selectTab("subscriptions");
      this.$nextTick(() =>
        this.$eventBus.$emit("psiDetail:openCortesia")
      );
    },
    openNewBankAccount() {
      this.selectTab("bank");
      this.$nextTick(() =>
        this.$eventBus.$emit("psiDetail:openNewBankAccount")
      );
    },
    openResetStripe() {
      this.selectTab("connect-accounts");
      this.$nextTick(() =>
        this.$eventBus.$emit("psiDetail:openResetStripe")
      );
    },
    openChangeSlug() {
      this.selectTab("account");
      this.showSummary = true;
      this.$nextTick(() =>
        this.$eventBus.$emit("psiDetail:openChangeSlug")
      );
    },
    selectGroup(group) {
      // Ao clicar num grupo, abre a primeira sub-aba (se já não estiver nele)
      if (this.activeGroupId === group.id) return;
      this.selectTab(group.tabs[0].id);
    },
    tabBadge(tabId) {
      const i = this.item || {};
      switch (tabId) {
        case "appointments":
          return i.appointments_count || null;
        case "recurrencies":
          return i.recurrencies_as_psy?.length || null;
        case "review":
          return i.latest_ratings?.length || null;
        case "subscriptions":
          return i.subscriptions?.length || null;
        case "transfer":
          return i.payouts?.length || null;
        case "connect-accounts":
          return i.connect_accounts_count || null;
        case "coupons":
          return i.coupons?.length || null;
        default:
          return null;
      }
    },
    changeEmailClicked() {
      this.changeEmailModal.toggle();
    },
    changeCRPPhotosClicked() {
      this.resetCRPPhotosForm();
      this.changeCRPPhotosModal.toggle();
    },
    handleChangeEmail() {
      this.submitting = true;
      changeEmail({ id: this.item.id, email: this.form.email }, () => {
        this.$eventBus.$emit("showToast", {
          title: "Email alterado",
          msg: `O email foi alterado com sucesso`,
        });
        this.changeEmailModal.toggle();
        this.getData();
        this.submitting = false;
      });
    },
    handlechangeCRPPhotos() {
      this.submitting = true;
      this.errorMessage = "";
      const values = { ...this.changeCRPPhotosForm };
      if (values.document_image) {
        values.document_image = values.document_image.file;
      }
      if (values.document_in_hand) {
        values.document_in_hand = values.document_in_hand.file;
      }
      console.log(values);

      changeCRPPhotos(
        {
          id: this.item.id,
          document_image: values.document_image,
          document_in_hand: values.document_in_hand,
        },
        () => {
          this.$eventBus.$emit("showToast", {
            title: "fotos do CRP alteradas",
            msg: `Fotos do CRP alteradas com sucesso`,
          });
          this.changeCRPPhotosModal.toggle();
          this.getData();
          this.submitting = false;
        }
      );
    },
    handleChangeActive() {
      changeActive(this.item, () => this.getData());
    },
    async handleChangeApprove() {
      this.isApproving = true;
      changeApprove(this.item, () => {
        this.$eventBus.$emit("showToast", {
          title: !this.item.approved
            ? "Usuário aprovado"
            : "Usuário Desaprovado",
          msg: !this.item.approved
            ? `O Usuário foi aprovado com sucesso`
            : `O Usuário foi desaprovado`,
        });
        this.getData();
        this.isApproving = false;
      });
    },
    handleGivePremium() {
      givePremium(this.item, () => {
        this.$eventBus.$emit("showToast", {
          title: "Psi promovido para premium",
          msg: `O Psi é agora é um assinante`,
        });
        this.getData();
      });
    },
    handleRemovePremium() {
      removePremium(this.item, () => {
        this.$eventBus.$emit("showToast", {
          title: "Premium removido do psi",
          msg: `O Psi é agora é um usuário free`,
        });
        this.getData();
      });
    },
    handleChangeAgenda() {
      changeAgenda(this.item, () => {
        this.getData();
      });
    },
    handleCouponDetail(id) {
      this.$router.push({ path: `${this.$paths.coupons.detail}/${id}` });
    },
    async changeCallProvider(value) {
      try {
        let params = { call_provider: value };
        await this.$userService.update(this.item?.id, params);
        this.getData();
      } catch (error) {
        console.log(error);
      }
    },
    loadChangeLogsTab() {
      if (!this.changeLogsLoaded) {
        this.changeLogsLoaded = true;
      }
    },
    loadAdminLogsTab() {
      if (!this.adminLogsLoaded) {
        this.adminLogsLoaded = true;
      }
    },
    loadNotificationsTab() {
      if (!this.notificationsLoaded) {
        this.notificationsLoaded = true;
      }
    },
    loadAppointmentsTab() {
      if (!this.appointmentsLoaded) {
        this.appointmentsLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.appointmentsComponent) {
            this.$refs.appointmentsComponent.loadAppointments();
          }
        });
      }
    },
    loadConnectAccountsTab() {
      if (!this.connectAccountsLoaded) {
        this.connectAccountsLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.connectAccountsComponent) {
            this.$refs.connectAccountsComponent.loadConnectAccounts();
          }
        });
      }
    },
    loadSubscriptionsTab() {
      // Tab loaded
    },
    closeReactivateModal() {
      this.showReactivateModal = false;
      this.confirmReactivate = false;
    },
    async handleReactivateAccount() {
      this.reactivating = true;
      try {
        await this.$userService.network.post("api/reactivate-user", {
          user_id: this.item.id,
        });
        this.$eventBus.$emit("showToast", {
          title: "Conta reativada",
          msg: "A conta foi reativada com sucesso",
        });
        this.closeReactivateModal();
        this.getData();
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao reativar conta",
        });
      } finally {
        this.reactivating = false;
      }
    },
    closeResetPasswordModal() {
      this.showResetPasswordModal = false;
      this.resetPasswordLink = null;
    },
    async handleGenerateResetLink() {
      this.generatingResetLink = true;
      try {
        const res = await this.$userService.network.post(
          `api/users/${this.item.id}/generate-password-reset-link`
        );
        this.resetPasswordLink = res.data?.data?.reset_link || res.data?.reset_link;
        this.$eventBus.$emit("showToast", {
          title: "Link gerado",
          msg: "Link de redefinição de senha gerado com sucesso",
        });
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao gerar link",
        });
      } finally {
        this.generatingResetLink = false;
      }
    },
    copyResetLink() {
      navigator.clipboard.writeText(this.resetPasswordLink);
      this.$eventBus.$emit("showToast", {
        title: "Copiado",
        msg: "Link copiado para a área de transferência",
      });
    },
  },
};
